module.exports = __webpack_public_path__ + "img/H-63-ER-450-MI.71bbc902.png";